import { Component, input } from "@angular/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";

@Component({
  selector: "vl-loader-skeleton",
  standalone: true,
  imports: [NgxSkeletonLoaderModule],
  templateUrl: "./loader-skeleton.component.html",
  styleUrl: "./loader-skeleton.component.scss",
})
export class LoaderSkeletonComponent {
  count = input(10);
  height = input(150);
}
